import Vue from 'vue';
const Bus = new Vue();

const install = function(Vue) {
    Vue.prototype.$bus = Bus;
};
export default install;
